import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Payouts from "./pages/Payouts";
import Layout from "./components/Layout";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [agentData, setAgentData] = useState(null);

  useEffect(() => {
    // Check if agent is already logged in
    const storedAgent = localStorage.getItem("agentData");
    if (storedAgent) {
      setAgentData(JSON.parse(storedAgent));
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (data) => {
    setAgentData(data);
    setIsAuthenticated(true);
    localStorage.setItem("agentData", JSON.stringify(data));
  };

  const handleLogout = () => {
    setAgentData(null);
    setIsAuthenticated(false);
    localStorage.removeItem("agentData");
    localStorage.removeItem("loginTime");
  };

  return (
    <Router>
      <div className='sl-agent-app-wrapper'>
        <Routes>
          <Route path='/login' element={isAuthenticated ? <Navigate to='/dashboard' /> : <Login onLogin={handleLogin} />} />
          <Route
            path='/*'
            element={
              isAuthenticated ? (
                <Layout agentData={agentData} onLogout={handleLogout}>
                  <Routes>
                    <Route path='/dashboard' element={<Dashboard agentData={agentData} />} />
                    <Route path='/clients' element={<Clients agentData={agentData} />} />
                    <Route path='/payouts' element={<Payouts agentData={agentData} />} />
                    <Route path='/' element={<Navigate to='/dashboard' />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to='/login' />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
